import Box from "@mui/material/Box";
import { FC, useEffect, useState } from "react";
import { COLOR_BLACK } from "shared/theme/colors";
import FieldLabel from "../components/FieldLabel";
import BrowseFile from "./components/BrowseFile";
import UploadNewFile from "./components/UploadNewFile";
import SkeletonUploadImageField from "./skeleton";

type UploadImageFieldProps = {
  imageFile: File | null;
  setImageFile: (file: File | null) => void;
  label: string;
  isLoading: boolean;
  index?: number;
  disabled?: boolean;
};

const UploadImageField: FC<UploadImageFieldProps> = ({
  imageFile,
  setImageFile,
  label,
  isLoading,
  index,
  disabled,
}) => {
  const [picture, setPicture] = useState<string>("");

  useEffect(() => {
    if (imageFile) {
      if (imageFile instanceof File) {
        setPicture(URL.createObjectURL(imageFile));
      } else {
        setPicture(imageFile);
      }
    } else {
      setPicture("");
    }
  }, [imageFile]);

  const onLogoUploaded = (e: { target: { files: FileList | null } | null }) => {
    if (e.target && e.target.files) {
      const imageFile = e.target.files[0];
      setImageFile(imageFile);
      setPicture(URL.createObjectURL(imageFile));
    }
  };

  return (
    <Box>
      <FieldLabel label={label} labelColor={COLOR_BLACK} />
      {isLoading && <SkeletonUploadImageField />}
      {!isLoading && picture && (
        <UploadNewFile
          onLogoUploaded={onLogoUploaded}
          imgUrl={picture}
          fileSize={imageFile?.size}
          disabled={disabled}
        />
      )}
      {!picture && !isLoading && (
        <BrowseFile
          onLogoUploaded={onLogoUploaded}
          index={index}
          disabled={disabled}
        />
      )}
    </Box>
  );
};

export default UploadImageField;
